import customerModel from "./customer.modal.js";

export default {
  0: [
    {
      name: "First Name",
      id: customerModel.FIRST_NAME,
    },
    {
      name: "Last Name",
      id: customerModel.LAST_NAME,
    },
    {
      name: "Phone",
      id: customerModel.PHONE,
    },
    {
      name: "Appointment Time Window",
      id: "appointment_time_window",
    },
  ],
  1: [
    {
      name: "First Name",
      id: customerModel.FIRST_NAME,
    },
    {
      name: "Last Name",
      id: customerModel.LAST_NAME,
    },
    {
      name: "Phone",
      id: customerModel.PHONE,
    },
    {
      name: "Job Number",
      id: "Job_Number",
    },
    {
      name: "Job Type",
      id: "Job_Type",
    },
    {
      name: "Job Cancellation Link",
      id: "Job_Cancellation_Link",
    },
  ],
  2: [
    {
      name: "First Name",
      id: customerModel.FIRST_NAME,
    },
    {
      name: "Last Name",
      id: customerModel.LAST_NAME,
    },
    {
      name: "Phone",
      id: customerModel.PHONE,
    },
    {
      name: "Job Number",
      id: "Job_Number",
    },
    {
      name: "Job Type",
      id: "Job_Type",
    },
    {
      name: "Contract",
      id: "contract",
    },
  ],
  3: [
    {
      name: "First Name",
      id: customerModel.FIRST_NAME,
    },
    {
      name: "Last Name",
      id: customerModel.LAST_NAME,
    },
    {
      name: "Job Number",
      id: "Job_Number",
    },
    {
      name: "Job Type",
      id: "Job_Type",
    },
  ],
  4: [
    {
      name: "First Name",
      id: customerModel.FIRST_NAME,
    },
    {
      name: "Last Name",
      id: customerModel.LAST_NAME,
    },
    {
      name: "Job Number",
      id: "Job_Number",
    },
    {
      name: "Job Type",
      id: "Job_Type",
    },
  ],
  5: [
    {
      name: "First Name",
      id: customerModel.FIRST_NAME,
    },
    {
      name: "Last Name",
      id: customerModel.LAST_NAME,
    },
    {
      name: "Web Contract Agreement Template Name",
      id: "Web_Contract_Agreement_Template_Name",
    },
    {
      name: "Job Confirmation Link",
      id: "Job_Confirmation_Link",
    },
  ],
  6: [
    {
      name: "Job Number",
      id: "Job_Number",
    },
    {
      name: "Job Type",
      id: "Job_Type",
    },
  ],
  8: [
    {
      name: "Job Number",
      id: "Job_Number",
    },
    {
      name: "Job Type",
      id: "Job_Type",
    },
  ],
  12: [
    {
      name: "First Name",
      id: customerModel.FIRST_NAME,
    },
    {
      name: "Last Name",
      id: customerModel.LAST_NAME,
    },
    {
      name: "Phone",
      id: customerModel.PHONE,
    },
    {
      name: "Job Number",
      id: "Job_Number",
    },
    {
      name: "Job Type",
      id: "Job_Type",
    },
    {
      name: "Appointment Time Window",
      id: "appointment_time_window",
    },
    {
      name: "Technician’s Close Out Link",
      id: "technician_close_out_link",
    },
  ],
  13: [
    {
      name: "First Name",
      id: customerModel.FIRST_NAME,
    },
    {
      name: "Last Name",
      id: customerModel.LAST_NAME,
    },
    {
      name: "Job Number",
      id: "Job_Number",
    },
    {
      name: "Job Type",
      id: "Job_Type",
    },
    {
      name: "Appointment Time Window",
      id: "appointment_time_window",
    },
  ],
  16: [
    {
      name: "Job Accept & Reject Link",
      id: "accept_job_link",
    },
  ],
};
